export default __webpack_public_path__ + "static/media/nebari.bd96931d.png";